import cogoToast from "cogo-toast";
import { listToMatrix } from "../../utils/helpers";

import httpRequest from "../../ajax";
import { getJobSearchFiltersFromLLM } from "../../services/nlpSearchHelper";
import {
  APPLY_TO_JOB,
  CREATE_BUSINESS_JOB, // active
  GET_SUBSIDIARIES, // active
  GET_BUSINESS_JOBS, // active
  RESET_JOBS, //
  CREATE_ORGANOGRAM,
  POST_ASSIGN_ROLES,
  POST_UNASSIGN_ROLES,
  GET_COMPANY_STAFF,
  EDIT_ORGANOGRAM,
  GET_ROLES,
  GET_MY_ADMIN_BUSINESS_JOBS, //
  SAVE_BUSINESS_REF, //
  GET_BUSINESS_REFS, //
  GET_AVG_TIME_TO_HIRE, //
  GET_COST_OF_HIRE_ANALYTICS,
  GET_EMPLOYEE_ENGAGEMENT_ANALYTICS,
  GET_REFERAL_RATIO_ANALYTICS,
  GET_AVERAGE_TIME_TO_HIRE_ANALYTICS,
  GET_PIE_CHART_ANALYTICS,
  GET_ANNUAL_EMPLOYEES, //
  PROCESS_QUALITY_OF_HIRE, //
  GET_QUALITY_OF_HIRE, //
  RESET_JOB,
  DELETE_SAVED_JOBS,
  ERROR,
  GET_OFFERS_JOBS,
  GET_APPLIED,
  GET_JOB_LEVELS,
  GET_MY_JOBS,
  GET_SAVED_JOBS,
  RESET_JOB_CREATED,
  SAVE_JOB,
  BUSINESS_SEARCH_JOBS,
  // LIKE_UNLIKE_JOB,
  GET_REFERRAL_JOBS,
  APPLY_TO_RECRUITER_JOB,
  GET_EMPLOYEE_ENGAGEMENT,
  GET_EMPLOYEE_REFERRAL_RATIO,
  GET_COST_OF_HIRE,
} from "../actionTypes";

// Post new job to the business timeline...
export const createBusinessJobAction = (dispatch, data) => {
  return httpRequest("post", "/business/jobs/create", data)
    .then(({ data: { data } }) => {
      const action = { type: CREATE_BUSINESS_JOB, payload: data };
      dispatch(action);
      getBusinessJobsAction(dispatch, 1);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

// Get subsidiaries by a company id
export const getSubsidiaries = (dispatch, company_id) =>
  httpRequest("get", `/business/subsidiaries/${company_id}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_SUBSIDIARIES, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const clearJobCreated = (dispatch) =>
  dispatch({ type: RESET_JOB_CREATED });

//   Get Business Jobs action
export const getBusinessJobsAction = (dispatch, page) =>
  httpRequest("get", `/business/jobs/${page}/10`)
    .then(({ data: { data } }) => {
      const action = { type: GET_BUSINESS_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const resetJob = (dispatch) => dispatch({ type: RESET_JOB });

export const getOffersAction = (dispatch) =>
  httpRequest("get", `/insiight/jobOffers`)
    .then(({ data: { data } }) => {
      // console.log("Offers", data);
      const action = { type: GET_OFFERS_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const resetAllJobs = (dispatch) => dispatch({ type: RESET_JOBS });

export const getMyJobsAction = (dispatch) =>
  httpRequest("get", "/jobs/byMe/1/50")
    .then(({ data: { data } }) => {
      const action = { type: GET_MY_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getJobLevelsAction = (dispatch) =>
  httpRequest("get", "/jobs/levels")
    .then(({ data: { data } }) => {
      const action = { type: GET_JOB_LEVELS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
export const jobReferralLinkClicked = (data) =>
  httpRequest("post", "/insiight/admin/jobReferralLinkClicked", data)
    .then(() => {})
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
    export const createOrganogram = (dispatch, data) =>
  httpRequest("post", "/organogram/create-role", data)
    .then(({ data: { data } }) => {
      const action = { type: CREATE_ORGANOGRAM, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
    export const editRole = (dispatch, id, data) =>
  httpRequest("put", `/organogram/edit-role/${id}`, data)
    .then(({ data: { data } }) => {
      const action = { type: EDIT_ORGANOGRAM, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
   
export const getRole = (dispatch, company_id) => {
  return httpRequest("post", "/organogram/company-roles", company_id)
    .then(({ data: { data } }) => {
      const action = { type: GET_ROLES, payload: data };
      dispatch(action);
      return action;  
    })
    .catch(({ response }) => {
      const errorPayload = {
        payload: response?.data?.message || "Unknown error occurred",
        type: ERROR,
      };
      console.error("Error fetching roles:", errorPayload); 
      dispatch(errorPayload);  
      return errorPayload; 
    });
};
   
export const getCompanyStaff = (dispatch, company_id) => {
  return httpRequest("post", "/organogram/company-staffs", company_id)
    .then(({ data: { data } }) => {
      const action = { type: GET_COMPANY_STAFF, payload: data };
      dispatch(action);
      return action;  
    })
    .catch(({ response }) => {
      const errorPayload = {
        payload: response?.data?.message || "Unknown error occurred",
        type: ERROR,
      };
      console.error("Error fetching roles:", errorPayload); 
      dispatch(errorPayload);  
      return errorPayload; 
    });
};
   
export const assignRoles = (dispatch, roleId, data) => {
  return httpRequest("post", `/organogram/assign-role/${roleId}`, data)
    .then(({ data: { data } }) => {
      const action = { type: POST_ASSIGN_ROLES, payload: data };
      dispatch(action);
      return action;  
    })
    .catch(({ response }) => {
      const errorPayload = {
        payload: response?.data?.message || "Unknown error occurred",
        type: ERROR,
      };
      console.error("Error fetching roles:", errorPayload); 
      dispatch(errorPayload);  
      return errorPayload; 
    });
};
export const unAssignRoles = (dispatch, data) => {
  return httpRequest("post", "/organogram/unassign-role", data)
    .then(({ data: { data } }) => {
      const action = { type: POST_UNASSIGN_ROLES, payload: data };
      dispatch(action);
      return action;  
    })
    .catch(({ response }) => {
      const errorPayload = {
        payload: response?.data?.message || "Unknown error occurred",
        type: ERROR,
      };
      console.error("Error fetching roles:", errorPayload); 
      dispatch(errorPayload);  
      return errorPayload; 
    });
};

  

export const getApplications = (dispatch) =>
  httpRequest("get", "/jobs/application")
    .then(({ data: { data } }) => {
      const action = { type: GET_APPLIED, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getSavedJobs = (dispatch, page) =>
  httpRequest("get", `/jobs/saved/${page}/10`)
    .then(({ data: { data } }) => {
      const action = { type: GET_SAVED_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const saveJobAction = (dispatch, job_id) =>
  httpRequest("post", "/jobs/saved/create", { job_id })
    .then(({ data: { data } }) => {
      const action = { type: SAVE_JOB, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
    

export const applyAction = (dispatch, job_id, refCode, func) =>
  httpRequest("post", "/jobs/application/create", { job_id, refCode })
    .then(({ data: { data } }) => {
      const action = { type: APPLY_TO_JOB, payload: data };
      dispatch(action);
      func();
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

// Apply to recuiter's jobs
export const applyToRecruiterJob = (dispatch, job_id, recruiterId, func) => {
  // console.log("Applying to Recruiters Jobs");
  const rData = {
    job_id,
    recruiterId: parseInt(recruiterId, 10),
  };

  return httpRequest("post", "/jobs/application/applyToRercruiterJob", rData)
    .then(({ data: { data } }) => {
      const action = { type: APPLY_TO_RECRUITER_JOB, payload: data };
      dispatch(action);
      func();
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const searchJobAction = async (dispatch, term, navigate = () => {}) => {
  try {
    const trimmedTerm = (term || "").trim();

    // 1. Try to get AI filters for semantic search (e.g., "backend developer" matches "engineer")
    let filters = await getJobSearchFiltersFromLLM(trimmedTerm);

    // 2. FALLBACK: If AI fails or returns null, build a manual filter object
    if (!filters || typeof filters !== "object") {
      console.warn("LLM failed, using fallback search");
      filters = {
        role_title: trimmedTerm,
        sort: "latest"
      };
    }

    console.log("AI filters before sanitization:", filters);
    
    // Always include the raw term for backend fallback matching
    filters.__raw = trimmedTerm;

    // 3. Sanitize filters to prevent backend PHP errors
    // Remove any fields that might cause "non-numeric value encountered" errors
    if (filters.job_level && typeof filters.job_level === 'object') {
      // Convert object to string if needed
      filters.job_level = filters.job_level.name || filters.job_level.level || JSON.stringify(filters.job_level);
    }
    
    // Ensure salary is properly formatted as object with min/max if it exists
    if (filters.salary && typeof filters.salary === 'object') {
      if (typeof filters.salary.min !== 'number') filters.salary.min = parseFloat(filters.salary.min) || 0;
      if (typeof filters.salary.max !== 'number') filters.salary.max = parseFloat(filters.salary.max) || null;
    } else if (filters.salary) {
      // If salary is not an object, remove it to prevent errors
      delete filters.salary;
    }
    
    // Ensure no_of_staff is properly formatted as object with min/max if it exists
    if (filters.no_of_staff && typeof filters.no_of_staff === 'object') {
      if (typeof filters.no_of_staff.min !== 'number') filters.no_of_staff.min = parseInt(filters.no_of_staff.min) || 0;
      if (typeof filters.no_of_staff.max !== 'number') filters.no_of_staff.max = parseInt(filters.no_of_staff.max) || null;
    } else if (filters.no_of_staff) {
      // If no_of_staff is not an object, remove it to prevent errors
      delete filters.no_of_staff;
    }
    
    // Ensure sort is a valid string
    if (filters.sort && typeof filters.sort !== 'string') {
      filters.sort = 'latest';
    }
    
    // Ensure skills_required is an array if it exists
    if (filters.skills_required && !Array.isArray(filters.skills_required)) {
      filters.skills_required = [filters.skills_required];
    }
    
    // Remove any undefined or null values
    Object.keys(filters).forEach(key => {
      if (filters[key] === undefined || filters[key] === null) {
        delete filters[key];
      }
    });

    console.log("AI filters after sanitization:", filters);

    // 4. Ensure a sort key exists
    if (!filters.sort) {
      filters.sort = "latest";
    }

    // FINAL SAFETY CHECK: Ensure filters is always a valid object before JSON.stringify
    if (!filters || typeof filters !== "object") {
      console.error("CRITICAL: filters is still invalid, forcing safe object");
      filters = {
        role_title: trimmedTerm || "developer",
        sort: "latest",
        __raw: trimmedTerm
      };
    }

    // 4. Determine display term for UI
    const searchTerm =
      (trimmedTerm.length > 0 && trimmedTerm.length <= 3)
        ? trimmedTerm
        : (filters.role_title ||
          filters.skills_required?.[0] ||
          filters.campany_name ||
          term);

    const searchParams = encodeURIComponent(JSON.stringify(filters));

    const response = await httpRequest("get", `/jobs/${searchParams}/search`);
    
    if(!response.data || !response.data.data) {
        throw new Error("Invalid response from server");
    }

    const { data } = response.data;

    navigate();
    const action = { type: BUSINESS_SEARCH_JOBS, payload: { data, term: searchTerm } };
    dispatch(action);
    return action;

  } catch(error) {
      console.error("Business Search Error:", error);
      cogoToast.error(`No result for ${term}`);
      return {
        payload: error?.response?.data?.message || "Search failed",
        type: ERROR,
      };
  }
};

export const deleteSavedJob = (dispatch, job_id) =>
  httpRequest("post", `/jobs/saved/${job_id}/delete`, {})
    .then(({ data: { data } }) => {
      const action = { type: DELETE_SAVED_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const likeUnlikeJob = (dispatch, data) =>
  httpRequest("post", "/jobs/like/likeUnLike", data)
    .then
    // ({ data: { data } }
    //   ) => {
    // const action = { type: LIKE_UNLIKE_JOB, payload: data };
    // console.log("data payload", data);
    // dispatch(action);
    // return action;
    // }
    ()
    .catch(({ response }) => {
      // console.log("error res", response);
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const getSentReferralJobs = (dispatch, page) =>
  httpRequest("get", `/insiight/referrals/${page}/${10}`)
    .then(({ data: { data } }) => {
      // console.log("in action");
      const action = { type: GET_REFERRAL_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getReferralJobs = (dispatch) =>
  httpRequest("get", `/insiight/referrals`)
    .then(({ data: { data } }) => {
      // console.log("in action");
      const action = { type: GET_REFERRAL_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getAdminJobs = (dispatch, page) =>
  httpRequest("get", `/business/jobs/byMe/${page}/10`)
    .then(({ data: { data } }) => {
      // console.log("admin jobs", data);
      const action = { type: GET_MY_ADMIN_BUSINESS_JOBS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const saveBusinessRef = (dispatch, page, bData) =>
  httpRequest("post", `/business/jobs/saveToBusinessReferral`, bData)
    .then(({ data: { data } }) => {
      const action = { type: SAVE_BUSINESS_REF, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getBusinessRef = (dispatch, page) =>
  httpRequest("get", `/business/jobs/getBusinessRefJobs/${page}/10`)
    .then(({ data: { data } }) => {
      const action = { type: GET_BUSINESS_REFS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getAvgTimeToHire = (dispatch, cid) =>
  httpRequest("get", `/business/averageTimeToHire/${cid}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_AVG_TIME_TO_HIRE, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });



 

export const getAnnualEmployees = (dispatch, cid) =>
  httpRequest("get", `/business/annualEmployees/${cid}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_ANNUAL_EMPLOYEES, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const processQualityOfHire = (dispatch, qData) =>
  httpRequest("post", `/business/processQualityOfHire`, qData)
    .then(({ data: { data } }) => {
      const action = { type: PROCESS_QUALITY_OF_HIRE, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getQualityOfHire = (dispatch, cid) =>
  httpRequest("get", `/business/getQualityOfHire/${cid}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_QUALITY_OF_HIRE, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getEmployeeEngagement = (dispatch, cid) =>
  httpRequest("get", `/business/getEmployeeEngagement/${cid}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_EMPLOYEE_ENGAGEMENT, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const processEmployeeEngagement = (score) =>
  httpRequest("post", `/business/processEmployeeEngagement/${score}`)
    .then(({ data: { data } }) => {
      return data;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const getEmployeeReferralRatio = (dispatch, cid) =>
  httpRequest("get", `/business/getEmployeeReferralRatio/${cid}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_EMPLOYEE_REFERRAL_RATIO, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });

export const getCostOfHire = (dispatch, cid) =>
  httpRequest("get", `/business/getCostOfHire/${cid}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_COST_OF_HIRE, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      return {
        payload: response?.data?.message,
        type: ERROR,
      };
    });
 

 export const getCostOfHireAnalytics = (dispatch, cid) =>
 {
    httpRequest("get", `/recruiter/insight/analytics/costofhire/${cid}`)
      .then(({ data: { data } }) => {
        console.log("<<getCostOfHireAnalytics>>"+listToMatrix(data,2));
        const action = { type: GET_COST_OF_HIRE_ANALYTICS, payload: listToMatrix(data,2) };
        dispatch(action);
        return action;
      })
      .catch(({ response }) => {
          return {
          payload: response?.data?.message,
          type: ERROR,
        };
      })
    };

    export const getReferalRationalytics = (dispatch, cid) =>
    {
       httpRequest("get", `/recruiter/insight/analytics/referralratio/${cid}`)
         .then(({ data: { data } }) => {
           console.log("<<getReferalRationalytics>>"+JSON.stringify(data));
           const action = { type: GET_REFERAL_RATIO_ANALYTICS, payload: data };
           dispatch(action);
           return action;
         })
         .catch(({ response }) => {
             return {
             payload: response?.data?.message,
             type: ERROR,
           };
         })
       };

       export const getPieChartAnalytics = (dispatch, cid) =>
       {
          httpRequest("get", `/recruiter/insight/analytics/shortlistAndInterviewRatio/${cid}`)
            .then(({ data: { data } }) => {
              console.log("<<getPieChartAnalytics>>"+JSON.stringify(data));
              const action = { type: GET_PIE_CHART_ANALYTICS, payload: data };
              dispatch(action);
              return action;
            })
            .catch(({ response }) => {
                return {
                payload: response?.data?.message,
                type: ERROR,
              };
            })
        };


      export const getAverageTimeToHireAnalytics = (dispatch, cid) =>
       {
          httpRequest("get", `/recruiter/insight/analytics/timeToCompleteShortlist/${cid}`)
            .then(({ data: { data } }) => {
              console.log("<<getAverageTimeToHireAnalytics>>"+JSON.stringify(data));
              const action = { type: GET_AVERAGE_TIME_TO_HIRE_ANALYTICS, payload: data };
              dispatch(action);
              return action;
            })
            .catch(({ response }) => {
                return {
                payload: response?.data?.message,
                type: ERROR,
              };
            })
        };
        
        

  export const getEmploymentEngagementAnalytics = (dispatch, cid) =>
    {
      httpRequest("get", `/recruiter/insight/analytics/employeeengagement/${cid}`)
         .then(({ data: { data } }) => {
           console.log("<<getEmploymentEngagementAnalytics>>"+listToMatrix(data,3));
           const action = { type: GET_EMPLOYEE_ENGAGEMENT_ANALYTICS, payload: listToMatrix(data,3) };
           dispatch(action);
           return action;
         })
         .catch(({ response }) => {
             return {
             payload: response?.data?.message,
             type: ERROR,
           };
         })
       };


 